<template>
  <div>
    <p class="noYPadding text">
      {{ $t(`copySite.step0.from`) }}
    </p>
    <v-row>
      <v-col class="noYPadding">
        <VAutocomplete
          ref="autocompleteRef"
          v-model="data.selectedSite"
          :label="$t('copySite.step0.select')"
          :items="data.sites"
          :loading="loading"
          class="text-field-transparent"
          itemValue="id"
          itemText="name"
          cacheItems
          outlined
          solo
          flat
          data-cy="selectSite"
          @search="debouncedSendQueryParams"
        >
          <template #withInfiniteScroll>
            <div v-intersect="endIntersect" />
          </template>
        </VAutocomplete>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { debounce } from 'lodash';
import VAutocomplete from '@/components/shared/widgets/forms/VuetifyInputs/VAutocomplete.vue';

export default {
    name: 'SiteSelection',
    components: {
        VAutocomplete,
    },
    data() {
        return {
            data: {
                sites: [],
                selectedSite: null,
            },
            debouncedSendQueryParams: debounce(this.fetchQuery, 500),
            queryParams: { perpage: 10 },
            loading: false,
        };
    },
    computed: {
        ...mapGetters([
            'site',
        ]),
    },
    watch: {
        'data.selectedSite': {
            handler() {
                this.updateData();
            },
            deep: true,
        },
    },
    async created() {
        this.loading = true;
        await this.getSites();
        this.loading = false;
    },
    methods: {
        ...mapActions({
            setSite: 'changeSelectedSite',
        }),
        updateData() {
            const site = this.data.sites.find(s => s.id === this.data.selectedSite);
            this.setSite(site);
            this.$emit('sendData', { selectedSite: this.data.selectedSite });
        },
        async getSites(nextPage = 1) {
            this.queryParams.page = nextPage;
            const { data } = await this.$rq.getSites(this.queryParams);
            const filteredSites = data.sites.filter(site => site.id !== this.site.id); // remove current site from the list.
            this.data.sites = [...this.data.sites, ...filteredSites];
            this.queryParams = {
                ...this.queryParams,
                ...data.pagination,
            };
        },
        async fetchQuery(search) {
            this.loading = true;
            this.queryParams = {
                ...this.queryParams,
                search,
            };
            await this.getSites();
            this.loading = false;
        },
        async endIntersect(_, __, isIntersecting) {
            const condition = this.queryParams.currentPage < this.queryParams.totalPageCount;
            if (isIntersecting && condition) {
                await this.getSites(this.queryParams.currentPage + 1);
                // access "v-autocomplete" ref
                const ref = this.$refs?.autocompleteRef?.$refs?.autocomplete;
                if (ref?.onScroll) {
                // workaround to refresh list after adding new items.
                    ref.onScroll();
                }
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.noYPadding {
    padding-bottom: 0px;
    padding-top: 0px;
}
.text {
    font-size: 18px;
}
</style>
